import * as actionTypes from 'containers/Groups/action-types';

export const selectTab = (value: string) => ({
  type: actionTypes.TAB_SELECT,
  payload: value
});

export const openViewGroupModal = (id: string) => ({
  type: actionTypes.VIEW_GROUP,
  payload: id
});

export const setShow = (value: boolean) => ({
  type: actionTypes.SHOW_SET,
  payload: value
});

export const setGroup = (group: any) => ({
  type: actionTypes.GROUP_SET,
  payload: group
});

export const openDeleteConfirmationModal = (id: string, context: string) => ({
  type: actionTypes.DELETE_GROUP,
  payload: { id, context }
});

export const openDeleteFavModal = (id: string, name: string) => ({
  type: actionTypes.DELETE_FAV,
  payload: { id, name }
});

export const setShowDelete = (value: boolean) => ({
  type: actionTypes.SHOW_DELETE_SET,
  payload: value
});
